import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../ProfitLossSlice";
import { fetchProfitLoss } from "../ProfitLossThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const ProfitLossFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.profitLoss);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  // handleFilterChange only queues the update, so running the report right here
  // would still use the old (default) filters — flag it and run it from the
  // next effect, once the drill-down filters have been applied.
  const [drillReady, setDrillReady] = useState(false);
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("filterType", "Date Wise");
      const fromDate = searchParams.get("fromDate");
      if (fromDate) {
        handleFilterChange("fromDate", fromDate);
      }
      handleFilterChange("toDate", path);
      setDrillReady(true);
    }
  }, []);
  useEffect(() => {
    if (drillReady) handleReport();
  }, [drillReady]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    dispatch(fetchProfitLoss({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        <Col xs={24} sm={12} md={4}>
        <label>Filter Type</label>
        <Select
          style={{ width: "100%" }}
          placeholder="Filter Type"
          value={filters.filterType || undefined}
          onChange={(value) => handleFilterChange("filterType", value)}
          options={[
            { label: "Life Time", value: "Lifetime" },
            { label: "Date Wise", value: "Date Wise" },
          ]}
        />
      </Col>

        {filters.filterType === "Date Wise" ? (
          <CommonDateRangeFilter
            filters={filters}
            onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
            }}
          />
        ) : (
          ""
        )}

        <Col
          xs={24}
          sm={12}
          md={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      @media (min-width: 768px) {
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
}

  `}</style>
    </Card>
  );
};

export default ProfitLossFilters;
